import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchFactsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchFacts: FC<SrWidgetMatchFactsProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true };
    return <SrWidget widgetName="match.factsandfigures" widgetProps={widgetProps} {...props} />;
};
